import { createReducer } from "../ReduxHelpers";
import * as TreeHelpers from "../../helpers/TreeHelpers";
import _ from "lodash/fp";
import { arrayMove } from "baseui/dnd-list";
import {
  pushTreeItem,
  updateTreeItem,
  traverseTreeArray,
  getTreeItemParent,
} from "../../helpers/TreeHelpers";
import * as AppEnums from "../../constants/AppEnums";

const templateInitialState = {
  activeTemplate: {},
  templates: [],
  total: 0,
  loading: false,
  error: false,
  isCloneInProgress: false,
};
function createParameterGroupBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}
function createParameterGroupSuccess(state, action) {
  let newState = { ...state };
  let paramGroups = [...state.activeTemplate.parameterGroups || []];
  paramGroups.push({
    id: action.payload.createParameterGroup.id,
    name: action.payload.createParameterGroup.name,
    type: AppEnums.TREE_ITEM_TYPES.GROUP,
    children: action.payload.createParameterGroup.children,
  });  
  newState.activeTemplate.parameterGroups = [...paramGroups];
  return newState;
}
function createParameterGroupFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function deleteParameterGroupSuccess(state, action) {
  let newState = { ...state };
  let paramGroups = state.activeTemplate.parameterGroups.filter(item => item.id !==  action.payload.deleteParameterGroup.id);  
  newState.activeTemplate.parameterGroups = paramGroups;
  newState.activeTemplate.selectedGroup = null;
  newState.activeTemplate.inProgress = false;
  return newState;
}


function updateSelectedGroup(state, action) {
  let newState = { ...state };
  Object.assign(newState.activeTemplate.selectedGroup, action.payload.group);
  return newState;
}
function updateSelectedParameter(state, action) {
  let newState = { ...state };
  let selectedParam = newState.activeTemplate.selectedGroup.children.find(
    (param) => param.id === action.payload.id
  );
  if (selectedParam) {
    Object.assign(selectedParam, action.payload);
  }
  return newState;
}
function setActiveTemplate(state, action) {
  let newState = { ...state };
  newState.activeTemplate = {
    ...newState.templatesList.find(
      (template) => template.id === action.payload.templateId
    ),
  };
  return newState;
}
function createNewTemplateBegin(state, action) {
  let newState = { ...state };
  newState.isLoading = true;
  newState.created= false;
  newState.deleted = false;
  return newState;
}

function createNewTemplateSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate = { ...action.payload.createTemplate };
  newState.isLoading = false;
  newState.created = true;
  return newState;
}
function createNewTemplateFailure(state, action) {
  let newState = { ...state };
  newState.isLoading = false;
  newState.error = true;
  newState.errorMessage = action.payload;
  newState.created = false
  return newState;
}
function fetchTemplatesBegin(state, action) {
  let newState = { ...state };
  newState.isLoading = true;
  newState.searchError = false;
  newState.created = false;
  newState.clonedSuccess = false;
  newState.deleted = false;
  newState.searchErrorMessage = "";
  return newState;
}

function fetchTemplatesSuccess(state, action) {
  let newState = { ...state };
  newState.templatesList = [...(action.payload.listTemplates?.items || [])];
  newState.total = action.payload.listTemplates?.total || 0;
  newState.isLoading = false;
  return newState;
}

function fetchTemplatesFailure(state, action) {
  let newState = { ...state };
  newState.isLoading = false;
  newState.searchErrorMessage = action.payload;
  newState.searchError = true;
  newState.templatesList = [];
  newState.total = 0;
  return newState;
}

function reorderTemplateParameters(state, action) {
  let newState = Object.assign({}, state);
  let newArray = arrayMove(
    newState.activeTemplate.selectedGroup.children,
    action.payload.oldIndex,
    action.payload.newIndex
  );
  newState.activeTemplate.selectedGroup.children = [...newArray];
  newState.activeTemplate.parameterGroups.forEach((item) => {
    if (item.id === newState.activeTemplate.selectedGroup.id) {
      item.children = [...newState.activeTemplate.selectedGroup.children];
    }
  });
  return newState;
}

function setSelectedParameter(state, action) {
  let newState = Object.assign({}, state);
  let selectedItem = newState.activeTemplate.selectedGroup.children.find(
    (item) => item.id === action.payload.id
  );
  newState.activeTemplate.selectedGroup.children.forEach(
    (item) => (item.isSelected = false)
  );
  if (selectedItem) {
    let index =
      newState.activeTemplate.selectedGroup.children.indexOf(selectedItem);
    newState.activeTemplate.selectedGroup.children[index].isSelected = true;
  }
  return newState;
}
function setSelectedGroup(state, action) {
  let newState = Object.assign({}, state);
  let currentSelectedGroup = newState.activeTemplate.parameterGroups.find(
    (item) => item.isSelected
  );
  if (currentSelectedGroup?.id === action.payload.id) return newState;
  newState.activeTemplate.parameterGroups.forEach((item) => {
    item.isSelected = false;
    item.isExpanded = false;
  });
  newState.activeTemplate.selectedGroup = {};
  if (!currentSelectedGroup || currentSelectedGroup.id !== action.payload.id) {
    let selectedGroup = state.activeTemplate.parameterGroups.find(
      (item) => item.id === action.payload.id
    );
    if (selectedGroup) {
      selectedGroup.isSelected = true;
      selectedGroup.isExpanded = true;
      newState.activeTemplate.selectedGroup = { ...selectedGroup };
    }
  }
  return newState;
}
function setSelectedFolder(state, action) {
  let newState = Object.assign({}, state);
  console.log("setSelectedFolder called")
  traverseTreeArray(
    newState.activeTemplate.folders,
    (folder) => {
      folder.isSelected = false
      folder.isEditing = false
    }
  );
  console.log("updateTreeItem called")
  updateTreeItem(newState.activeTemplate.folders, action.payload.id, {
    isSelected: true,
  });
  console.log("findTreeItem called")
  let selectedFolder = TreeHelpers.findTreeItem(
    newState.activeTemplate.folders,
    (folder) => folder.isSelected
  );
  console.log("getTreeItemParent called")
  let nodeParent = getTreeItemParent(
    newState.activeTemplate.folders,
    selectedFolder
  );
  console.log(nodeParent);
  traverseTreeArray(newState.activeTemplate.folders, (folder) => {
    if (TreeHelpers.isNodeAncestor(folder, selectedFolder)) {
      folder.isExpanded = true;
    }
  });
  newState.activeTemplate.selectedFolder = { ...selectedFolder };
  return newState;
}
function createTemplateParameterItemBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.inProgress = true;
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}
function createTemplateParameterItemSuccess(state, action) {
  let newState = Object.assign({}, state);
  let paramItems = [...(newState.activeTemplate.selectedGroup.children || [])];
  paramItems.push({ ...action.payload.createParameterItem });
  newState.activeTemplate.selectedGroup.children = [...paramItems];
  let paramGroups = [...newState.activeTemplate.parameterGroups];
  let selectedGroupIdx = paramGroups.findIndex(item => item.id === newState.activeTemplate.selectedGroup.id)
  paramGroups[selectedGroupIdx].children = [...paramItems];
  paramGroups[selectedGroupIdx].children.sort((a, b) => a.name.localeCompare(b.name));
  newState.activeTemplate.parameterGroups = [...paramGroups]
  newState.activeTemplate.updated = true;
  newState.activeTemplate.inProgress = false;
  return newState;
}
function createTemplateParameterItemFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = action.payload;
  newState.activeTemplate.inProgress = false;
  return newState;
}
function deleteParameterItemBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.inProgress = true;
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}
function deleteTemplateParameterItemSuccess(state, action) {
  let newState = Object.assign({}, state);
  let paramItems = newState.activeTemplate.selectedGroup.children.filter(item=> item.id !== action.payload.deleteParameterItem.id);
  newState.activeTemplate.selectedGroup.children = [...paramItems];
  let paramGroups = [...newState.activeTemplate.parameterGroups];
  let selectedGroupIdx = paramGroups.findIndex(item => item.id === action.payload.deleteParameterItem.groupId)
  paramGroups[selectedGroupIdx].children = [...paramItems];
  newState.activeTemplate.parameterGroups = [...paramGroups]
  newState.activeTemplate.updated = true;
  newState.activeTemplate.inProgress = false;
  return newState;
}
function deleteParameterItemFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  newState.activeTemplate.inProgress = false;
  return newState;
}


function updateParameterItemBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.inProgress = true;
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}



function updateTemplateParameterItemSuccess(state, action) {
  const newState = { ...state };
  
  // Find the group based on the updatedParameter's groupId
  const groupIndex = newState.activeTemplate.parameterGroups.findIndex(item => item.id === action.payload.updateParameterItem.groupId);

  if (groupIndex === -1) {
      return state; // If group is not found, return the original state.
  }

  const editedGroup = { ...newState.activeTemplate.parameterGroups[groupIndex] };

  // Find the index of the parameter to update
  const selectedItemIdx = editedGroup.children.findIndex(item => item.id === action.payload.updateParameterItem.id);
  
  if (selectedItemIdx === -1) {
      return state; // If parameter is not found, return the original state.
  }

  // Replace the children of the group with the updatedParameter
  const oldParam = editedGroup.children[selectedItemIdx];
  editedGroup.children[selectedItemIdx] = {
      ...action.payload.updateParameterItem,
      isSelected: oldParam.isSelected
  };
  editedGroup.children.sort((a, b) => a.name.localeCompare(b.name));
  newState.activeTemplate.parameterGroups[groupIndex] = editedGroup;
  if(editedGroup.id === newState.activeTemplate.selectedGroup.id){
    newState.activeTemplate.selectedGroup = editedGroup;
  }

  // Set the group of new state as the updated parameter group
  // newState.activeTemplate.selectedGroup.= [...editedGroup.children];
  newState.activeTemplate.updated = true;

  newState.activeTemplate.inProgress = false;
  return newState;
}

function createTemplateFolderBegin(state, action) {
  let newState = Object.assign({}, state);
  return newState;
}


function createTemplateFolderSuccess(state, action) {
  let newState = Object.assign({}, state);
  let newFolders = [...newState.activeTemplate.folders]

  pushTreeItem(newFolders, action.payload.createFolderItem);
  newState.activeTemplate.folders = [...newFolders];
  return newState;
}

function updateTemplateFolderBegin(state, action) {
  let newState = Object.assign({}, state);
  return newState;
}



function updateTemplateFolderSuccess(state, action) {
  let newState = Object.assign({}, state);
  let newFolders = [...newState.activeTemplate.folders]
  updateTreeItem(newFolders, action.payload.updateFolderItem.id, {
    isSelected: true,
    isEditing: false,
    name: action.payload.updateFolderItem.name
  });
  newState.activeTemplate.folders = [...newFolders];
  return newState;
}

function deleteParametersGroupBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.inProgress = true;
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}

function deleteParameterGroupFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.inProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function deleteTemplateFolderSuccess(state, action) {
  let newState = Object.assign({}, state);
  let newFolders = [...newState.activeTemplate.folders]
  TreeHelpers.removeTreeItem(
    newFolders,
    (item) => item.id === action.payload.deleteFolderItem?.id
  );
  // let newFolders = [...state.activeTemplate.folders];
  // state.activeTemplate.folders = [...newFolders];
  newState.activeTemplate.folders = [...newFolders];
  newState.activeTemplate.inProgress = false;
  return newState;
}

function deleteTemplateFolderFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function toggleTemplateFolder(state, action) {
  let newState = Object.assign({}, state);
  updateTreeItem(newState.activeTemplate.folders, action.payload.id, {
    isExpanded: !action.payload.isExpanded,
  });
  return newState;
}

function fetchActiveTemplateBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.isLoading = true;
  newState.created = false;
  newState.clonedSuccess = false;
  newState.activeTemplate.fetchError = false;
  newState.activeTemplate.fetchErrorMessage = "";
  return newState;
}

function fetchActiveTemplateSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.isLoading = false;
  let {parameterGroups, folders, ...template} = { ...action.payload.getTemplate };
  newState.activeTemplate = {...template};
  newState.activeTemplate.parameterGroups = (parameterGroups.items || [])
  .map(item => {
    return {
      ...item,
      type: AppEnums.TREE_ITEM_TYPES.GROUP,
      children: (item.children?.items || []).sort((a, b) => a.name.localeCompare(b.name))
    }
  })
  .sort((a, b) => a.name.localeCompare(b.name)); 
  let flat_folders = [...action.payload.getTemplate.folders.items]
  let newFolders = TreeHelpers.convertListToTree(flat_folders);
  newState.activeTemplate.folders = [...newFolders];
  return newState;
}
function fetchActiveTemplateFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.isLoading = false;
  newState.activeTemplate.fetchError = true;
  newState.activeTemplate.fetchErrorMessage = action.payload;
  return newState;
}
function updateFoldersNode(state, action) {
  let newState = Object.assign({}, state);
  updateTreeItem(
    newState.activeTemplate.folders,
    action.payload.node.id,
    action.payload.folder
  );
  return newState;
}

function updateFolderItemBegin(state, action) {
  let newState = Object.assign({}, state);
  updateTreeItem(newState.activeTemplate.folders, action.payload.folderId, {
    name: action.payload.newName,
    isEditing: false,
  });
  //TODO: update state accordingly
  return newState;
}

function updateFolderItemSuccess(state, action) {
  let newState = Object.assign({}, state);
  updateTreeItem(
    newState.activeTemplate.folders,
    action.payload.updateFolder.id,
    action.payload.updateFolder
  );
  return newState;
}

function updateTemplateBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.updateInProgress = true;  
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}


function updateTemplateSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.updateInProgress = false;  
  newState.activeTemplate = Object.assign(
    newState.activeTemplate,
    action.payload.updateTemplate
  );
  newState.activeTemplate.isDirty = false;
  return newState;
}

function updateTemplateFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate.updateInProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function updateActiveTemplateProperties(state, action) {
  let newState = Object.assign({}, state);
  newState.activeTemplate = Object.assign(
    newState.activeTemplate,
    action.payload.template
  );
  newState.activeTemplate.isDirty = true;
  return newState;
}
function unpublishTemplateBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.publishInProgress = true;
  return newState;
}
function unpublishTemplateSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.publishInProgress = false;
  newState.activeTemplate.published = action.payload.unpublishTemplate.published;
  return newState;
}
function unpublishTemplateFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.publishInProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}
function publishTemplateBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.publishInProgress = true;
  return newState;
}

function publishTemplateSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.publishInProgress = false;
  newState.activeTemplate.published = action.payload.publishTemplate.published;
  newState.activeTemplate.modelerId = action.payload.publishTemplate.modelerId
  return newState;
}

function publishTemplateFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.publishInProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}
function cloneTemplateBegin(state, action) {
  let newState = { ...state };
  newState.isCloneInProgress = true;
  return newState;
}
function cloneTemplateSuccess(state, action) {
  let newState = { ...state };
  // newState.activeTemplate = { ...action.payload.cloneTemplate };
  newState.isCloneInProgress = false;
  newState.cloneError = false;
  newState.cloneErrorMessage = "";
  newState.clonedSuccess = true;
  newState.activeTemplate = { ...action.payload.cloneTemplate };
  return newState;
}

function cloneTemplateFailure(state, action) {
  let newState = { ...state };
  newState.isCloneInProgress = false;
  newState.cloneError = true;
  newState.cloneErrorMessage = action.payload;
  return newState;
}


function updateTemplateThumbnailImage(state, action) {
  let newState = { ...state };
  newState.activeTemplate.thumbnailImageUrl = action.payload.imageUrl;
  return newState;
}

function updateTemplateModelerThumbnailImage(state, action) {
  let newState = { ...state };
  newState.activeTemplate.modelerThumbnailImageUrl = action.payload.imageUrl;
  return newState;
}
function deleteTemplateBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.deleteInProgress = true;
  return newState;
}
function deleteTemplateSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.deleteInProgress = false;
  newState.activeTemplate = {};
  newState.deleted = true;
  return newState;
}
function deleteTemplateFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.deleteInProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function updateTemplateParameterGroupBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.error = false;
  newState.activeTemplate.errorMessage = "";
  return newState;
}

function updateTemplateParameterGroupSuccess(state, action) {
  let newState = { ...state };
  let idx = newState.activeTemplate.parameterGroups.findIndex(item => item.id === action.payload.updateParameterGroup.id);
  let old = newState.activeTemplate.selectedGroup;
  newState.activeTemplate.parameterGroups[idx]["name"] = action.payload.updateParameterGroup.name;
  let newSelectedGroup = newState.activeTemplate.parameterGroups.find(item => item.id === old.id);  
  newState.activeTemplate.selectedGroup = {...newSelectedGroup};
  newState.activeTemplate.parameterGroups.sort((a, b) => a.name.localeCompare(b.name));
  return newState;
}

function updateTemplateParameterGroupFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function resetActiveTemplate(state, action) {
  let newState = { ...state };
  newState.activeTemplate = { ...templateInitialState.activeTemplate};
  return newState;
}

function fetchFileContentBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.fileContent = "";
  newState.activeTemplate.fileContentLoading = true;
  return newState;
}

function fetchFileContentSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.fileContent = action.payload.getFileContent?.content;
  newState.activeTemplate.fileContentLoading = false;
  return newState;
}

function fetchFileContentFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.fileContent = "";
  newState.activeTemplate.fileContentLoading = false;
  return newState;
}

function updateFileContentBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.fileContentLoading = true;
  return newState;
}

function updateFileContentSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.fileContent = action.payload.updateFileContent?.content;
  newState.activeTemplate.fileContentLoading = false;
  return newState;
}

function updateFileContentFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.fileContentLoading = false;
  return newState;
}

function addObjectFileUploadCancelToken(state, action) {
  const newUploadProgress = { ...state.uploadProgress };
  delete newUploadProgress[action.filename];

  return {
    ...state,
    cancelTokens: {
      ...state.cancelTokens,
      [action.filename]: action.cancelToken
    },
    uploadProgress: newUploadProgress
  };
}

function removeObjectFileUploadCancelToken(state, action) {
  const newCancelTokens = { ...state.cancelTokens };
  delete newCancelTokens[action.filename];
  const newCompletedUploads = state.completedUploads?.filter(filename => filename !== action.filename);
  const newUploadProgress = { ...state.uploadProgress };
  delete newUploadProgress[action.filename];
  return {
    ...state,
    cancelTokens: newCancelTokens,
    uploadProgress: newUploadProgress,
    completedUploads: newCompletedUploads
  };
}
function setObjFileUploadProgress(state, action) {
  return {
    ...state,
    uploadProgress: {
      ...state.uploadProgress,
      [action.filename]: action.progress
    }
  };
}

function fetchProductsBegin(state, action) {
  let newState = { ...state };
  newState.isLoadingProductsSearch = true;
  newState.searchErrorProducts = false;
  newState.searchErrorMessageProducts = "";
  return newState;
}

function fetchProductsSuccess(state, action) {
  let newState = { ...state };
  newState.productsList = [...(action.payload.listProducts?.items || [])];
  newState.total = action.payload.listProducts?.total || 0;
  newState.isLoadingProductsSearch = false; 
  return newState;
}

function fetchProductsFailure(state, action) {
  let newState = { ...state };
  newState.isLoadingProductsSearch = false;
  newState.searchErrorProducts = true;
  newState.searchErrorMessageProducts = action.payload;
  return newState;
}

function publishProductBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.sellInProgress = true;
  return newState;
}


function publishProductSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.sellInProgress = false;
  newState.activeTemplate.inMarket = action.payload.publishProduct?.id ? true : false;
  return newState;
}

function publishProductFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.sellInProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}

function unpublishProductBegin(state, action) {
  let newState = { ...state };
  newState.activeTemplate.sellInProgress = true;
  return newState;
}

function unpublishProductSuccess(state, action) {
  let newState = { ...state };
  newState.activeTemplate.sellInProgress = false;
  newState.activeTemplate.inMarket = action.payload.unpublishProduct?.id ? false : true;
  return newState;
}

function unpublishProductFailure(state, action) {
  let newState = { ...state };
  newState.activeTemplate.sellInProgress = false;
  newState.activeTemplate.error = true;
  newState.activeTemplate.errorMessage = action.payload;
  return newState;
}



export const templateReducers = createReducer(templateInitialState, {
  SET_ACTIVE_TEMPLATE_ACTION: setActiveTemplate,
  FETCH_TEMPLATES_SUCCESS_ACTION: fetchTemplatesSuccess,
  FETCH_TEMPLATES_FAILURE_ACTION: fetchTemplatesFailure,
  FETCH_TEMPLATES_BEGIN_ACTION: fetchTemplatesBegin,
  FETCH_TEMPLATE_SUCCESS_ACTION: fetchActiveTemplateSuccess,
  FETCH_TEMPLATE_BEGIN_ACTION: fetchActiveTemplateBegin,
  FETCH_TEMPLATE_FAILURE_ACTION: fetchActiveTemplateFailure,
  DELETE_TEMPLATE_FOLDER_SUCCESS_ACTION: deleteTemplateFolderSuccess,
  DELETE_TEMPLATE_FOLDER_FAILURE_ACTION: deleteTemplateFolderFailure,
  REORDER_TEMPLATE_PARAMETERS_ACTION: reorderTemplateParameters,
  SET_SELECTED_PARAMETER_ACTION: setSelectedParameter,
  SET_SELECTED_GROUP_ACTION: setSelectedGroup,
  
  CREATE_TEMPLATE_FOLDER_SUCCESS_ACTION: createTemplateFolderSuccess,
  CREATE_TEMPLATE_FOLDER_BEGIN_ACTION: createTemplateFolderBegin,
  UPDATE_TEMPLATE_FOLDER_SUCCESS_ACTION: updateTemplateFolderSuccess,
  UPDATE_TEMPLATE_FOLDER_BEGIN_ACTION: updateTemplateFolderBegin,
  TOGGLE_TEMPLATE_FOLDER_ACTION: toggleTemplateFolder,
  UPDATE_FOLDERS_NODE_ACTION: updateFoldersNode,
  
  UPDATE_TEMPLATE_BEGIN_ACTION: updateTemplateBegin,
  UPDATE_TEMPLATE_SUCCESS_ACTION: updateTemplateSuccess,
  UPDATE_TEMPLATE_FAILURE_ACTION: updateTemplateFailure,
  UPDATE_ACTIVE_TEMPLATE_PROPERTIES_ACTION: updateActiveTemplateProperties,
  CREATE_NEW_TEMPLATE_SUCCESS_ACTION: createNewTemplateSuccess,
  CREATE_NEW_TEMPLATE_BEGIN_ACTION: createNewTemplateBegin,
  CREATE_NEW_TEMPLATE_FAILURE_ACTION: createNewTemplateFailure,
  SET_SELECTED_FOLDER_ACTION: setSelectedFolder,
  UPDATE_SELECTED_GROUP_ACTION: updateSelectedGroup,
  UNPUBLISH_TEMPLATE_BEGIN_ACTION: unpublishTemplateBegin,
  UNPUBLISH_TEMPLATE_SUCCESS_ACTION: unpublishTemplateSuccess,
  UNPUBLISH_TEMPLATE_FAILURE_ACTION: unpublishTemplateFailure,
  PUBLISH_TEMPLATE_BEGIN_ACTION: publishTemplateBegin,
  PUBLISH_TEMPLATE_SUCCESS_ACTION: publishTemplateSuccess,
  PUBLISH_TEMPLATE_FAILURE_ACTION: publishTemplateFailure,
  UPDATE_SELECTED_PARAMETER_ACTION: updateSelectedParameter,
  CLONE_TEMPLATE_BEGIN_ACTION: cloneTemplateBegin,
  CLONE_TEMPLATE_SUCCESS_ACTION: cloneTemplateSuccess,
  CLONE_TEMPLATE_FAILURE_ACTION: cloneTemplateFailure,
  UPDATE_TEMPLATE_THUMBNAIL_IMAGE: updateTemplateThumbnailImage,
  UPDATE_TEMPLATE_MODELER_THUMBNAIL_IMAGE: updateTemplateModelerThumbnailImage,
  DELETE_TEMPLATE_BEGIN_ACTION: deleteTemplateBegin,
  DELETE_TEMPLATE_SUCCESS_ACTION: deleteTemplateSuccess,
  DELETE_TEMPLATE_FAILURE_ACTION: deleteTemplateFailure,
  RESET_ACTIVE_TEMPLATE_ACTION: resetActiveTemplate,
  // Folder Item
  UPDATE_FOLDER_ITEM_BEGIN_ACTION: updateFolderItemBegin,
  UPDATE_FOLDER_ITEM_SUCCESS_ACTION: updateFolderItemSuccess,


  // Parameter Item
  CREATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION: createTemplateParameterItemBegin,
  CREATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION: createTemplateParameterItemSuccess,
  CREATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION: createTemplateParameterItemFailure,
  UPDATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION: updateParameterItemBegin,
  UPDATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION: updateTemplateParameterItemSuccess,
  UPDATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION: createTemplateParameterItemFailure,
  DELETE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION: deleteParameterItemBegin,  
  DELETE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION: deleteTemplateParameterItemSuccess,
  DELETE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION: deleteParameterItemFailure,

  // Parameter Group
  UPDATE_TEMPLATE_PARAMETER_GROUP_BEGIN_ACTION: updateTemplateParameterGroupBegin,
  UPDATE_TEMPLATE_PARAMATER_GROUP_SUCCESS_ACTION: updateTemplateParameterGroupSuccess,
  UPDATE_TEMPLATE_PARAMATER_GROUP_FAILURE_ACTION: updateTemplateParameterGroupFailure,
  CREATE_PARAMETER_GROUP_BEGIN_ACTION: createParameterGroupBegin,
  CREATE_PARAMETER_GROUP_SUCCESS_ACTION: createParameterGroupSuccess,
  CREATE_PARAMETER_GROUP_FAILURE_ACTION: createParameterGroupFailure,
  DELETE_PARAMETERS_GROUP_SUCCESS_ACTION: deleteParameterGroupSuccess,
  DELETE_PARAMETERS_GROUP_BEGIN_ACTION: deleteParametersGroupBegin,
  DELETE_PARAMETERS_GROUP_FAILURE_ACTION: deleteParameterGroupFailure,

  // File Content
  FETCH_FILE_CONTENT_BEGIN_ACTION: fetchFileContentBegin,
  FETCH_FILE_CONTENT_SUCCESS_ACTION: fetchFileContentSuccess,
  FETCH_FILE_CONTENT_FAILURE_ACTION: fetchFileContentFailure,
  UPDATE_FILE_CONTENT_BEGIN_ACTION: updateFileContentBegin,
  UPDATE_FILE_CONTENT_SUCCESS_ACTION: updateFileContentSuccess,
  UPDATE_FILE_CONTENT_FAILURE_ACTION: updateFileContentFailure,

  //Object File Upload
  SET_OBEJCT_FILE_UPLOAD_PROGRESS_ACTION: setObjFileUploadProgress,
  ADD_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION: addObjectFileUploadCancelToken,
  REMOVE_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION: removeObjectFileUploadCancelToken,

  //Product
  FETCH_PRODUCTS_BEGIN_ACTION: fetchProductsBegin,
  FETCH_PRODUCTS_SUCCESS_ACTION: fetchProductsSuccess,
  FETCH_PRODUCTS_FAILURE_ACTION: fetchProductsFailure,
  PUBLISH_PRODUCT_BEGIN_ACTION: publishProductBegin,
  PUBLISH_PRODUCT_SUCCESS_ACTION: publishProductSuccess,
  PUBLISH_PRODUCT_FAILURE_ACTION: publishProductFailure,
  UNPUBLISH_PRODUCT_BEGIN_ACTION: unpublishProductBegin,
  UNPUBLISH_PRODUCT_SUCCESS_ACTION: unpublishProductSuccess,
  UNPUBLISH_PRODUCT_FAILURE_ACTION: unpublishProductFailure,

});
